import SolveSolution from "./SolveSolution.vue";
export default SolveSolution;
